
function Loading() {

    return (
        <img src={"/Spinner-1s-200px.svg"} alt={"Loading"} width={"50"} style={{'maxWidth': 200}}/>
    );
}

export default Loading;